import { Injectable } from '@angular/core';
import {NeoRestService} from '../neo-rest/neo-rest.service';

@Injectable()
export class NeoInventoryService {

  constructor(
      private _rest: NeoRestService
  ) { }

    /**
     * Envia la URL del hotel y los datos de fechas del inventario
     *
     * @param date
     * @param hotelId
     * @returns {Observable<any>}
     */
    getInventory(hotelId, date) {
        return this._rest.postRaw(`/hotel/inventory/${hotelId}`, date);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-inventory/neo-inventory.service.ts